module.exports = {

    types: {
        WORKLOAD_TYPE       : 'workloadType',
        TASKS_LIST_TYPE     : 'tasksListType',
        NOTES_LIST_TYPE     : 'notesListType',
        TASKS_BOARD_TYPE    : 'tasksBoardType',
        PROJECT_LIST_TYPE   : 'projectListType',
        UNIVERSAL_TYPE      : 'universalType',
    },

    itemsOptions: {
        CURRENT: 'current',
        ALL: 'all'
    },

    columnsOptions: {
        CURRENT: 'current',
        ALL: 'all'
    },

    grouping: {
        BY_TASK:            'byTask',
        BY_USER:            'byUser',
        BY_TASK_AND_USER:   'byTaskAndUser',
        BY_DATE:            'byDate',
        BY_TIME_REPORTS:    'timeReports'
    }
};